import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedRpmPatient } from "../../../../../Redux/actions/rpmActions";
import ViewPrescription from "./ViewPrescription";
import Reports from "./Reports";
import Layout from "../../../../Layouts";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { APP_ROUTES } from "../../../../../PageRouting/approutes";

const ViewAllRecords = ({ patientDetails }) => {
  const [activeTab, setActiveTab] = useState("PRESCRIPTION");
  const { selectedRpmPatient } = useSelector((state) => state.rpm);
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    if (!selectedRpmPatient) {
      const rpmPatientJson = sessionStorage.getItem("rpmPatient");
      const rpmPatientObject = rpmPatientJson
        ? JSON.parse(rpmPatientJson)
        : null;
      if (rpmPatientObject) dispatch(setSelectedRpmPatient(rpmPatientObject));
    }
  }, []);

  const handleBackClick = () => {
    history.push(APP_ROUTES.RPMPATIENTPALLETTE);
  };

  return (
    <Layout>
      <div className="">
        <div className="container h-[550px] overflow-y-scroll border-2 w-full mx-2 bg-white rounded-lg mt-6">
          <div className="flex items-center justify-between p-2">
            <h2 className="font-bold text-lg">Medical Records</h2>
            <ArrowLeftOutlined
              onClick={handleBackClick}
              className="text-xl mr-2 cursor-pointer hover:text-blue-500"
            />
          </div>
          <div className="flex mt-4 mb-4 px-2">
            {["PRESCRIPTION", "REPORTS"].map((tab, idx) => (
              <button
                key={idx}
                className={`px-4 py-2 ${idx === 0 ? "rounded-l-md" : "rounded-r-md"
                  } 
                          ${activeTab === tab
                    ? "bg-brand-primaryColor text-white"
                    : "bg-gray-200 text-black"
                  }`}
                onClick={() => setActiveTab(tab)}
              >
                {tab === "PRESCRIPTION" ? "Prescription" : "Reports"}
              </button>
            ))}
          </div>

          {activeTab === "PRESCRIPTION" && (
            <ViewPrescription
              selectedPatient={selectedRpmPatient}
              permissionData={{ prescription: "Y" }}
            />
          )}

          {activeTab === "REPORTS" && (
            <Reports
              selectedPatient={selectedRpmPatient}
              permissionData={{ reports: "Y" }}
            />
          )}
        </div>
      </div>
    </Layout>
  );
};

export default ViewAllRecords;
